import { TYPES } from './types';
import { k3docService } from '../services';

// Get all docs
export const getK3Docs = (query = {}) => async dispatch => {
  try {
    const res = await k3docService.getK3Docs(query);
    dispatch({
      type: TYPES.ACTION_GET_K3DOCS_SUCCESS,
      payload: res.data.data.docs
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3DOCS_FAIL,
      payload: err.response?.data || { message: 'Error getting docs' }
    });
  }
};

// Get a single doc
export const getK3Doc = (id) => async dispatch => {
  console.log('getK3Doc', id);
  try {
    const res = await k3docService.getK3Docs({ id });
    dispatch({
      type: TYPES.ACTION_GET_K3DOC_SUCCESS,
      payload: res.data.data.docs[0]
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3DOC_FAIL,
      payload: err.response?.data || { message: 'Error getting doc' }
    });
  }
};

// Set docs (create/update/delete)
export const setK3Docs = (docs, query = {}) => async dispatch => {
  try {
    const res = await k3docService.setK3Docs(docs, query);
    dispatch({
      type: TYPES.ACTION_SET_K3DOCS_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_SET_K3DOCS_FAIL,
      payload: err.response?.data || { message: 'Error setting docs' }
    });
  }
}; 